import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AlertService } from '@cpd-app/core-module/services';

@Component({
  selector: 'cpd-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
  @Input() public canClose: boolean;

  public alert$ = this.alertService.alert$;

  constructor(private alertService: AlertService) {}

  public close(): void {
    this.alertService.hideAlert();
  }
}
